import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import type { ActivitiesFiltersParams } from '@core/activities-types';
import { HttpApiService } from '@core/http-legacy';

import type { NotificationCounterFilteredStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterFilteredHttpService {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(filters: ActivitiesFiltersParams): Observable<NotificationCounterFilteredStore> {
    return this.httpApi.get('tracking/notifications/counters', { ...filters });
  }
}
